import packageJson from "../../../../package.json";

export const AMPLITUDE_API_KEY = import.meta.env.VITE_AMPLITUDE_API_KEY;
export const apiUrl = import.meta.env.VITE_API_URL;
export const appVersion = packageJson.version;
export const countryCode = "MY";
export const projectCode = "AHP";
export const themeKey = "AhaPay";
export const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
